<div [formGroup]="form">
<div class="sml-control-group tw-col-span-2">
  <div class="tw-flex tw-gap-1">
    <label for="postItem" class="sml-new-label !tw-block">Visibility <sup class="tw-text-alert-800">*</sup></label>
    <i-icon [name]="'info'" class="!tw-h-4 !tw-w-4 tw-text-grey-950 tw-cursor-pointer" *ngIf="accessType===campaignAccessType['Archived']" [smlTooltip]="'To mark a item as  Public, please restore the campaign first from the Archived Status'" [placement]="'top'" [mode]="'always'"></i-icon>
  </div>
    <div class="tw-inline-flex tw-w-full">
      <sml-toggle-radio-button [options]="itemPostType" formControlName="isPosted" groupIdentifier="postItem" [showSubheadings]="true" [subheadings]="itemPostSubHeadings" [iconName]="iconNameVisiblity"class="tw-w-full"
      [ngClass]="{'!tw-pointer-events-none !tw-opacity-70' : accessType===campaignAccessType['Archived']}" [notAllowedPointer]=" accessType===campaignAccessType['Archived']"></sml-toggle-radio-button>
      
    </div>
    <div class="sml-form-error" *ngIf="control['isPosted'].invalid && (control['isPosted'].dirty || control['isPosted'].touched)">
      <p *ngIf="control['isPosted'].errors?.['required']" class="tw-text-alert-800 tw-flex tw-items-center tw-gap-1">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Visibility is required.</span>
      </p>
    </div>
  </div>
</div>